import { Link } from "react-router-dom";
import "../Css/Admin.css";
import "./css/List.css";

export default function DataRow(props) {

  return (    
        <div className={props.number % 2 === 0 ? "row row-even" : "row row-odd"}>
            <div className="name">{props.nom} {props.prenom}</div>
            <div className="activity">{props.cocktail === 0 ? "non" : "oui"}</div>
            <div className="activity">{props.repas === 0 ? "non" : "oui"}</div>
            <div className="activity">{props.brunch === 0 ? "non" : "oui"}</div>         
        </div>
  );
}